exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".question-lock-alert[data-v-2f804290]{margin-bottom:16px}.form-actions[data-v-2f804290]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-top:28px}", "", {"version":3,"sources":["/workspace/src/views/training/pages/question/TrainingQuestionForm.vue"],"names":[],"mappings":"AACA,sCAAsC,kBAAkB,CACvD,AACD,+BAA+B,oBAAoB,oBAAoB,aAAa,qBAAqB,kBAAkB,yBAAyB,eAAe,CAClK","file":"TrainingQuestionForm.vue","sourcesContent":["\n.question-lock-alert[data-v-2f804290]{margin-bottom:16px\n}\n.form-actions[data-v-2f804290]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-top:28px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f804290","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/training/pages/question/TrainingQuestionForm.vue
// module id = 5689
// module chunks = 26